module.exports = __webpack_public_path__ + "img/Stone Tilt.72c09ef8.png";